import {Concept} from 'types';
import {useSchema} from 'schemas/hooks/useSchema';
import {useSchemaModifiers} from 'schemas/hooks/useSchemaModifiers';
import type {MetadataSchemas} from '../types';

export const useMetadataSchemas = (): MetadataSchemas => {
  const workSchema = useSchema(Concept.work);
  const expressionSchema = useSchema(Concept.expression);
  const manifestationSchema = useSchema(Concept.manifestation);

  const workSchemaModifiers = useSchemaModifiers(Concept.work);
  const expressionSchemaModifiers = useSchemaModifiers(Concept.expression);
  const manifestationSchemaModifiers = useSchemaModifiers(
    Concept.manifestation,
  );

  return {
    work: {schema: workSchema, modifiers: workSchemaModifiers},
    expression: {
      schema: expressionSchema,
      modifiers: expressionSchemaModifiers,
    },
    manifestation: {
      schema: manifestationSchema,
      modifiers: manifestationSchemaModifiers,
    },
  };
};
